import React, { useState } from "react";
import moment from "moment";
import "../../modules/customers/customers.css";
import ImageViewModal from "../modals/ImageViewModal";
import PdfView from "../modals/PdfView";
import { pdfChecker } from "../utilites/helper";
import eye from "../../assets/view-eye.svg";

const PharmacyView = ({ customerDetail }) => {
  const [imageModal, setImageModal] = useState(false);
  const [imageTitleData, setImageTitleData] = useState("");
  const [imageUrlData, setImageUrlData] = useState("");
  const [openPdf, setOpenPdf] = useState(false);
  const [pdfFileUrl, setPdfFileUrl] = useState(null);
  const [filename, setFileName] = useState(null);
  const pharmacyDoctor = customerDetail?.pharmacyDoctors;

  const PharmacyBasicDetails = [
    {
      heading: "Jivini’s Phramcy Code",
      title: customerDetail?.code ? customerDetail?.code : "--",
    },
    {
      heading: "Pharmacy Name",
      title: customerDetail?.pharmacy_name.toUpperCase()
        ? customerDetail?.pharmacy_name.toUpperCase()
        : "--",
    },

    {
      heading: "Drug License Number - 20A",
      title: customerDetail?.drug_licence_number_20_a
        ? customerDetail?.drug_licence_number_20_a
        : "--",
    },
    {
      heading: "Drug License Number - 20B",
      title: customerDetail?.drug_licence_number_20_b
        ? customerDetail?.drug_licence_number_20_b
        : "--",
    },
    {
      heading: "GST Number",
      title: customerDetail?.gst_number ? customerDetail?.gst_number : "--",
    },
    {
      heading: "Onboarding Type",
      title:
        customerDetail?.pharmacySubscribedVendors.length > 0
          ? customerDetail?.pharmacySubscribedVendors[0].onboarding_type
          : "--",
    },
    {
      heading: "Onboarded By",
      title: customerDetail?.onboardingFieldforce?.fieldForceUser?.name
        ? customerDetail?.onboardingFieldforce?.fieldForceUser?.name
        : "--",
    },
    {
      heading: "Onboarded Date & Time",
      title: customerDetail?.createdAt
        ? moment(customerDetail?.createdAt).format("DD MMM YYYY, HH:mm A")
        : "",
    },
    {
      heading: "Linked Head Quarters",
      title: customerDetail?.pharmacyHeadQuaters?.map((ele, index) => {
        return (
          <span key={index}>
            {index ? <span className="mx-1 color_b0b3c7">|</span> : ""}
            {ele?.headQuater?.name}
          </span>
        );
      }),
    },
  ];
  const pharmacyContactDetails = [
    {
      heading: "Mobile Number",
      title: `+91 ${customerDetail?.mobile}`
        ? `+91 ${customerDetail?.mobile}`
        : "--",
    },
    {
      heading: "Alternate Mobile Number",
      title: `+91 ${customerDetail?.alternate_mobile}`
        ? `+91 ${customerDetail?.alternate_mobile}`
        : "--",
    },
    {
      heading: "Email Address",
      title: customerDetail?.email ? customerDetail?.email : "--",
    },
    {
      heading: "Address",
      title:
        customerDetail?.address &&
        `${customerDetail?.address?.address_one}, ${customerDetail?.address?.address_two}, ${customerDetail?.address?.address_three}`,
    },
    {
      heading: "Landmark",
      title: customerDetail?.address?.landmark
        ? customerDetail?.address?.landmark
        : "--",
    },
    {
      heading: "State",
      title: customerDetail?.state?.name ? customerDetail?.state?.name : "--",
    },
    {
      heading: "District",
      title: customerDetail?.district?.name
        ? customerDetail?.district?.name
        : "--",
    },
    {
      heading: "City",
      title: customerDetail?.city?.name ? customerDetail?.city?.name : "--",
    },
    {
      heading: "Pincode",
      title: customerDetail?.pincode ? customerDetail?.pincode : "--",
    },
  ];
  return (
    <>
      {/* PHARMACY BASIC DETAILS */}
      <>
        {customerDetail?.is_details === true && (
          <div className="mb-4">
            <div className="basic-details-containersss px-2">
              <p className="basic-titlesss py-1 fw_600 fs_16">
                Pharmacy’s Basic Details
              </p>
            </div>

            <div className="product-details-container ms-2 ps-1">
              <div className="pt-3 row ">
                {PharmacyBasicDetails.map((item, index) => (
                  <div
                    key={index}
                    className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-1 me-4 px-2 customers-basic-heading-container"
                  >
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      {item.heading}
                    </h5>
                    <p
                      className={`fs_15 fn_Nunito fw_500 color_262c3d text-capitalize`}
                    >
                      {item.title}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {customerDetail?.is_contact_details == true && (
          <div className="mb-4">
            <div className="basic-details-containersss px-2">
              <p className="basic-titlesss py-1 fw_600 fs_16">
                Pharmacy’s Contact Details
              </p>
            </div>

            <div className="product-details-container ms-2 ps-1">
              <div className="pt-3 row row-cols-6">
                {pharmacyContactDetails.map((item, index) => (
                  <div className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      {item.heading}
                    </h5>
                    {item.heading === "Email Address" ? (
                      <p
                        className={`fs_15 fn_Nunito fw_500 color_262c3d text-truncate col-lg-10 email-slice `}
                        title={item.title}
                      >
                        {item.title}
                      </p>
                    ) : item.heading ? (
                      <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                        {item.title}
                      </p>
                    ) : (
                      <p className={`fs_15 fn_Nunito fw_500 color_262c3d`}>
                        {item.title}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        <>
          <>
            <div className="basic-details-container my-3 mt-4 my-auto d-flex align-items-center ">
              <label className="basic-title mx-2 mb-1">Documents</label>
            </div>
            <div className="row">
              <div className="col-xxl-4 col-6">
                <div className="mx-0 px-3">
                  <div className="my-2">
                    <div className="upload-image-label-container d-flex justify-content-between">
                      <label className="my-1 Neutral_Color">
                        Drug License Certificate - 20A
                      </label>
                    </div>
                    <div
                      className={`h-100`}
                      style={{
                        height: "25rem",
                        overflowY: "auto",
                        overflowX: "hidden",
                        scrollBehavior: "smooth",
                        position: "relative",
                      }}
                    >
                      {pdfChecker(
                        customerDetail?.drug_licence_certificate_20_a
                      ) ? (
                        <div className="manufacturer-doc-upload-container">
                          <iframe
                            src={`${customerDetail?.drug_licence_certificate_20_a}#toolbar=0`}
                            className="pdf-view-doc"
                          />
                        </div>
                      ) : (
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{ position: "relative" }}
                        >
                          <img
                            className="image-upload"
                            src={customerDetail?.drug_licence_certificate_20_a}
                            alt="Uploaded document"
                          />
                        </div>
                      )}
                      <div
                        className="w-100"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          top: "0",
                          maxWidth: "450px",
                        }}
                      >
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{
                            backgroundColor: "rgb(38, 44, 61, 0.5)",
                          }}
                        >
                          <div
                            className="align-items-center"
                            style={{
                              position: "absolute",
                              zIndex: "55",
                              top: "43%",
                              left: "40%",
                            }}
                          >
                            <img src={eye} className="mb-2" alt="Eye icon" />
                            {pdfChecker(
                              customerDetail?.drug_licence_certificate_20_a
                            ) ? (
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setOpenPdf(true);
                                  setPdfFileUrl(
                                    customerDetail?.drug_licence_certificate_20_a
                                  );
                                  setFileName("Drug License Certificate 20A");
                                }}
                              >
                                VIEW
                              </button>
                            ) : (
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setImageModal(true);
                                  setImageUrlData(
                                    customerDetail?.drug_licence_certificate_20_a
                                  );
                                  setFileName("Drug License Certificate 20A");
                                }}
                              >
                                VIEW
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-4 col-6">
                <div className="mx-0 px-3">
                  <div className="my-2">
                    <div className="upload-image-label-container d-flex justify-content-between">
                      <label className="my-1 Neutral_Color">
                        Drug License Certificate - 20B
                      </label>
                    </div>
                    <div
                      className={` h-100`}
                      style={{
                        height: "25rem",
                        overflowY: "auto",
                        overflowX: "hidden",
                        scrollBehavior: "smooth",
                        position: "relative",
                      }}
                    >
                      {pdfChecker(
                        customerDetail?.drug_licence_certificate_20_b
                      ) ? (
                        <div className="manufacturer-doc-upload-container">
                          <iframe
                            src={`${customerDetail?.drug_licence_certificate_20_b}#toolbar=0`}
                            className="pdf-view-doc"
                          />
                        </div>
                      ) : (
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{ position: "relative" }}
                        >
                          <img
                            className="image-upload"
                            src={customerDetail?.drug_licence_certificate_20_b}
                          />
                        </div>
                      )}
                      <div
                        className="w-100"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          top: "0",
                          maxWidth: "450px",
                        }}
                      >
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{
                            backgroundColor: "rgb(38, 44, 61, 0.5)",
                          }}
                        >
                          <div
                            className="align-items-center"
                            style={{
                              position: "absolute",
                              zIndex: "55",
                              top: "43%",
                              left: "40%",
                            }}
                          >
                            <img src={eye} className="mb-2" />
                            {pdfChecker(
                              customerDetail?.drug_licence_certificate_20_b
                            ) ? (
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setOpenPdf(true);
                                  setPdfFileUrl(
                                    customerDetail?.drug_licence_certificate_20_b
                                  );
                                  setFileName("Drug License Certificate 20B");
                                }}
                              >
                                VIEW
                              </button>
                            ) : (
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setImageModal(true);
                                  setImageUrlData(
                                    customerDetail?.drug_licence_certificate_20_b
                                  );
                                  setFileName("Drug License Certificate 20B");
                                }}
                              >
                                VIEW
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {customerDetail?.gst_certificate && (
                <div className="col-xxl-4 col-6">
                  <div className="mx-0 px-3">
                    <div className="my-2">
                      <div className="upload-image-label-container d-flex justify-content-between">
                        <label className="my-1 Neutral_Color">
                          GST Certificate
                        </label>
                      </div>
                      <div
                        className={` h-100`}
                        style={{
                          height: "25rem",
                          overflowY: "auto",
                          overflowX: "hidden",
                          scrollBehavior: "smooth",
                          position: "relative",
                        }}
                      >
                        {pdfChecker(customerDetail?.gst_certificate) ? (
                          <div className="manufacturer-doc-upload-container">
                            <iframe
                              src={`${customerDetail?.gst_certificate}#toolbar=0`}
                              className="pdf-view-doc"
                            />
                          </div>
                        ) : (
                          <div
                            className="manufacturer-doc-upload-container"
                            style={{ position: "relative" }}
                          >
                            <img
                              className="image-upload"
                              src={customerDetail?.gst_certificate}
                            />
                          </div>
                        )}
                        <div
                          className="w-100"
                          style={{
                            position: "absolute",
                            zIndex: "55",
                            top: "0",
                            maxWidth: "450px",
                          }}
                        >
                          <div
                            className="manufacturer-doc-upload-container"
                            style={{
                              backgroundColor: "rgb(38, 44, 61, 0.5)",
                            }}
                          >
                            <div
                              className="align-items-center"
                              style={{
                                position: "absolute",
                                zIndex: "55",
                                top: "43%",
                                left: "40%",
                              }}
                            >
                              <img src={eye} className="mb-2" />
                              {pdfChecker(customerDetail?.gst_certificate) ? (
                                <button
                                  className="fs_16 fw_600"
                                  style={{
                                    backgroundColor: "transparent",
                                    color: "#E7E5FF",
                                    border: "none",
                                  }}
                                  onClick={() => {
                                    setOpenPdf(true);
                                    setPdfFileUrl(
                                      customerDetail?.gst_certificate
                                    );
                                    setFileName("GST Certificate");
                                  }}
                                >
                                  VIEW
                                </button>
                              ) : (
                                <button
                                  className="fs_16 fw_600"
                                  style={{
                                    backgroundColor: "transparent",
                                    color: "#E7E5FF",
                                    border: "none",
                                  }}
                                  onClick={() => {
                                    setImageModal(true);
                                    setImageUrlData(
                                      customerDetail?.gst_certificate
                                    );
                                    setFileName("GST Certificate");
                                  }}
                                >
                                  VIEW
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div>
              <div className="basic-details-container my-3 mt-4  my-auto d-flex align-items-center ">
                <label className="basic-title mx-2 mb-1">
                  Onboarding Photos
                </label>
              </div>
              <div className="row">
                <div className="col-xxl-4 col-6 ">
                  <div className="mx-0 px-3">
                    <div className="my-2">
                      <div className="upload-image-label-container d-flex justify-content-between">
                        <label className="my-1 Neutral_Color">Pharmacy</label>
                      </div>

                      <div
                        className="manufacturer-doc-upload-container"
                        style={{ position: "relative" }}
                      >
                        <img
                          className="image-upload"
                          src={customerDetail?.pharmacy_photo}
                        />
                        <div
                          className="w-100"
                          style={{
                            position: "absolute",
                            zIndex: "55",
                            top: "0",
                            maxWidth: "450px",
                          }}
                        >
                          <div
                            className="manufacturer-doc-upload-container"
                            style={{
                              backgroundColor: "rgb(38, 44, 61, 0.6 )",
                            }}
                          >
                            <div
                              className="align-items-center px-2 mx-2 my-2"
                              style={{
                                position: "absolute",
                                zIndex: "55",
                                backgroundColor: "#fff",
                                borderRadius: "5px",
                              }}
                            >
                              <span className="fs_11 Medium_Purple fw_500">
                                {customerDetail?.pharmacy_photo_lat} ,
                                <span className="ms-1">
                                  {customerDetail?.pharmacy_photo_long}
                                </span>
                              </span>
                            </div>
                            <div
                              className="align-items-center"
                              style={{
                                position: "absolute",
                                zIndex: "55",
                                top: "43%",
                                left: "40%",
                              }}
                            >
                              <img src={eye} className="mb-2" />
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setImageModal(true);
                                  setImageTitleData("Pharmacy");
                                  setImageUrlData(
                                    customerDetail?.pharmacy_photo
                                  );
                                }}
                              >
                                VIEW
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-4 col-6 ">
                  <div className="mx-0 px-3">
                    <div className="my-2">
                      <div className="upload-image-label-container d-flex justify-content-between">
                        <label className="my-1 Neutral_Color">
                          Photo of Pharmacy’s Nameboard
                        </label>
                      </div>

                      <div
                        className="manufacturer-doc-upload-container"
                        style={{ position: "relative" }}
                      >
                        <img
                          className="image-upload"
                          src={customerDetail?.pharmacy_nameboard_photo}
                        />
                        <div
                          className="w-100"
                          style={{
                            position: "absolute",
                            zIndex: "55",
                            top: "0",
                            maxWidth: "450px",
                          }}
                        >
                          <div
                            className="manufacturer-doc-upload-container"
                            style={{
                              backgroundColor: "rgb(38, 44, 61, 0.6 )",
                            }}
                          >
                            <div
                              className="align-items-center px-2 mx-2 my-2"
                              style={{
                                position: "absolute",
                                zIndex: "55",
                                backgroundColor: "#fff",
                                borderRadius: "5px",
                              }}
                            >
                              <span className="fs_11 Medium_Purple fw_500">
                                {customerDetail?.pharmacy_nameboard_lat} ,
                                <span className="ms-1">
                                  {customerDetail?.pharmacy_nameboard_long}
                                </span>
                              </span>
                            </div>
                            <div
                              className="align-items-center"
                              style={{
                                position: "absolute",
                                zIndex: "55",
                                top: "43%",
                                left: "40%",
                              }}
                            >
                              <img src={eye} className="mb-2" />
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setImageModal(true);
                                  setImageTitleData(
                                    "Photo of Pharmacy’s Nameboard"
                                  );
                                  setImageUrlData(
                                    customerDetail?.pharmacy_nameboard_photo
                                  );
                                }}
                              >
                                VIEW
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </>
      </>

      {customerDetail?.pharmacySubscribedVendors[0].onboarding_type ===
        "attach" &&
        customerDetail.vendorDoctorPharmacy && (
          <>
            {/* DOCTOR BASIC DETAILS */}

            <div className="basic-details-containersss px-2 mt-4">
              <p className="basic-titlesss py-1 fw_600 fs_16">
                Doctor’s Basic details
              </p>
            </div>
            <div className="product-details-container ms-2 ps-1">
              <div className="pt-3 row ">
                <div className="mb-2 col-sm-6 col-md-5 col-xxl-1 me-4 px-2 customers-basic-heading-container">
                  <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                    Jivini’s Doctor Code
                  </h5>
                  <p
                    className={`fs_15 fn_Nunito text-nowrap fw_500 color_262c3d`}
                  >
                    {customerDetail.vendorDoctorPharmacy?.doctor?.code ?? "--"}
                  </p>
                </div>
                <div className="mb-2 col-sm-6 col-md-5 col-xxl-1 me-4 px-2 customers-basic-heading-container">
                  <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                    Doctor Name
                  </h5>
                  <p className={`fs_15 fn_Nunito fw_500 color_262c3d`}>
                    {customerDetail.vendorDoctorPharmacy?.doctor?.name ?? "--"}
                  </p>
                </div>
                {/* <div className="mb-2 col-sm-6 col-md-5 col-xxl-1 me-4 px-2 customers-basic-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      Pharmacy Type
                    </h5>
                    <p
                      className={`fs_15 fn_Nunito text-nowrap fw_500 color_262c3d`}
                    >
                      {
                        customerDetail.vendorDoctorPharmacy?.doctor
                          ?.pharmacy_type
                      }
                    </p>
                  </div> */}
                {/* <div className="mb-2 col-sm-6 col-md-5 col-xxl-1 me-4 px-2 customers-basic-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      Qualification
                    </h5>
                    <p
                      className={`fs_15 fn_Nunito text-nowrap fw_500 color_262c3d`}
                    >
                      {
                        customerDetail.vendorDoctorPharmacy?.doctor
                          ?.qualification
                      }
                    </p>
                  </div> */}
                <div className="mb-2 col-sm-6 col-md-5 col-xxl-1 me-4 px-2 customers-basic-heading-container">
                  <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                    Specialization
                  </h5>
                  <p
                    className={`fs_15 fn_Nunito text-nowrap fw_500 color_262c3d`}
                  >
                    {customerDetail.vendorDoctorPharmacy?.doctor?.specialization
                      ?.name ?? "--"}
                  </p>
                </div>
                <div className="mb-2 col-sm-6 col-md-5 col-xxl-1 me-4 px-2 customers-basic-heading-container">
                  <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                    MCI Number
                  </h5>
                  <p
                    className={`fs_15 fn_Nunito text-nowrap fw_500 color_262c3d`}
                  >
                    {customerDetail.vendorDoctorPharmacy?.doctor
                      ?.medical_council_registration_number ?? "--"}
                  </p>
                </div>
                <div className="mb-2 col-sm-6 col-md-5 col-xxl-1 me-4 px-2 customers-basic-heading-container">
                  <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                    Onboarded By
                  </h5>
                  <p className={`fs_15 fn_Nunito fw_500 color_262c3d`}>
                    {customerDetail?.onboardingFieldforce?.fieldForceUser
                      ?.name ?? "--"}
                  </p>
                </div>
                <div className="mb-2 col-sm-6 col-md-5 col-xxl-1 me-4 px-2 customers-basic-heading-container">
                  <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                    Onboarded Date & Time
                  </h5>
                  <p
                    className={`fs_15 fn_Nunito text-nowrap fw_500 color_262c3d`}
                  >
                    {customerDetail.vendorDoctorPharmacy?.createdAt &&
                      moment(
                        customerDetail.vendorDoctorPharmacy?.createdAt
                      ).format("DD MMM YYYY, HH:mm A")}
                  </p>
                </div>
                <div className="mb-2 col-sm-6 col-md-5 col-xxl-1 me-4 px-2 customers-basic-heading-container">
                  <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                    Linked Head Quarters
                  </h5>
                  <p className={`fs_15 fn_Nunito fw_500 color_262c3d`}>
                    {customerDetail.vendorDoctorPharmacy?.doctor?.doctorHeadQuaters?.map(
                      (ele, index) => {
                        return (
                          <span key={index}>
                            {index ? (
                              <span className="mx-1 color_b0b3c7">|</span>
                            ) : (
                              ""
                            )}
                            {ele?.headQuater?.name ?? "--"}
                          </span>
                        );
                      }
                    )}
                  </p>
                </div>
              </div>
            </div>

            {/* DOCTOR CONTACT DETAILS */}
            {/* <div className="mb-4">
              <div className="basic-details-container">
                <p className="basic-title">Doctor’s Contact Details</p>
              </div>
              <div className="product-details-container ms-2 ps-1">
                <div className="pt-3 row row-cols-6">
                  <div className="mb-2 col-10 col-sm-6 col-lg-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      Mobile Number
                    </h5>

                    <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                      <span className="me-1">
                        +
                        {
                          customerDetail.vendorDoctorPharmacy?.doctor
                            ?.country_code
                        }
                      </span>
                      {customerDetail.vendorDoctorPharmacy?.doctor?.mobile}
                    </p>
                  </div>
                  <div className="mb-2 col-10 col-sm-6 col-lg-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      Alternate Mobile Number
                    </h5>

                    <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                      <span className="me-1">+ 91</span>
                      {
                        customerDetail.vendorDoctorPharmacy?.doctor
                          ?.alternate_mobile
                      }
                    </p>
                  </div>
                  <div className="mb-2 col-10 col-sm-6 col-lg-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      Email Address
                    </h5>

                    <p
                      className={`fs_15 fn_Nunito fw_500 color_262c3d text-truncate col-lg-10 email-slice `}
                      title={customerDetail.vendorDoctorPharmacy?.doctor?.email}
                    >
                      {customerDetail.vendorDoctorPharmacy?.doctor?.email}
                    </p>
                  </div>
                  <div className="mb-2 col-10 col-sm-6 col-lg-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      Address
                    </h5>

                    <p className="fs_15 fn_Nunito fw_500 color_262c3d col-6">
                      {
                        customerDetail.vendorDoctorPharmacy?.doctor?.address
                          ?.address_one
                      }
                      ,
                      <span className="mx-1">
                        {
                          customerDetail.vendorDoctorPharmacy?.doctor?.address
                            ?.address_two
                        }
                        ,
                      </span>
                      {
                        customerDetail.vendorDoctorPharmacy?.doctor?.address
                          ?.address_three
                      }
                    </p>
                  </div>
                  <div className="mb-2 col-10 col-sm-6 col-lg-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      Landmark
                    </h5>

                    <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                      {
                        customerDetail.vendorDoctorPharmacy?.doctor?.address
                          ?.landmark
                      }
                    </p>
                  </div>
                  <div className="mb-2 col-10 col-sm-6 col-lg-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      State
                    </h5>

                    <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                      {customerDetail.vendorDoctorPharmacy?.doctor?.state?.name}
                    </p>
                  </div>
                  <div className="mb-2 col-10 col-sm-6 col-lg-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      District
                    </h5>

                    <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                      {
                        customerDetail.vendorDoctorPharmacy?.doctor?.district
                          ?.name
                      }
                    </p>
                  </div>
                  <div className="mb-2 col-10 col-sm-6 col-lg-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      City
                    </h5>

                    <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                      {customerDetail.vendorDoctorPharmacy?.doctor?.city?.name}
                    </p>
                  </div>
                  <div className="mb-2 col-10 col-sm-6 col-lg-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                    <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                      Pincode
                    </h5>

                    <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                      {customerDetail.vendorDoctorPharmacy?.doctor?.pincode}
                    </p>
                  </div>
                </div>
              </div>
            </div> */}
          </>
        )}
      <ImageViewModal
        show={imageModal}
        ShowClose={() => setImageModal(false)}
        imageTitleData={imageTitleData}
        imageUrlData={imageUrlData}
      />
      <PdfView
        show={openPdf}
        handleClose={() => setOpenPdf(false)}
        pdfUrl={pdfFileUrl}
        filename={filename}
      />
    </>
  );
};

export default PharmacyView;
